/* eslint-disable no-param-reassign */

const updateComponentRenderWidth = (
  component,
) => {
  component.renderWidths = {
    minWidthLarge: component.sizes.minWidthLarge.min,
    minWidthMedium: component.sizes.minWidthMedium.min,
    maxWidthMedium: component.sizes.maxWidthMedium.min
  };

  return component;
};

export const formatLayoutData = ({
  allComponents,
  myComponents,
  componentOptions = {},
  pageTheme
}) => {
  if (
    !allComponents
    || !myComponents
  ) {
    return null;
  }

  const addComponentToGroup = (formattedComponents, component) => {
    formattedComponents.all.push(component);

    if (pageTheme && component.theme) {
      formattedComponents.themed.push(component);
      return formattedComponents;
    }
    formattedComponents.nonThemed.push(component);
    return formattedComponents;
  };

  const formattedComponents = allComponents.filter(
    ({ __typename, customRenderId }) => {
      // prefer customRenderId to __typename, fallback to __typename
      return !!componentOptions[customRenderId] || !!myComponents[__typename];
    },
  ).reduce((acc, component) => {
    const { customRenderId } = component;
    if (!customRenderId || !componentOptions[customRenderId]) {
      updateComponentRenderWidth(component);
      return addComponentToGroup(acc, component);
    }

    const { sizes, theme } = componentOptions[customRenderId];

    // Some components may not have the maxWidthMedium size. This will set that size for those components.
    if (sizes) {
      component.sizes = sizes;
      if (!component.sizes.maxWidthMedium) {
        component.sizes.maxWidthMedium = { min: 12, max: 12 };
      }
    }

    component.theme = theme || component.theme;

    updateComponentRenderWidth(component);
    return addComponentToGroup(acc, component);
  }, { all: [], themed: [], nonThemed: [] });

  return formattedComponents;
};
